const readTourRateLimit = (rates, field) => {
  const stated = [...new Set((rates || []).map((rate) => rate[field]).filter((value) => value))];
  const limit = stated.length === 1 ? stated[0] : null;
  return limit;
};

export default readTourRateLimit;
